export default __webpack_public_path__ + "static/media/e42ed368fd2a7667bdd7cc009daaa72b.png";